import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { FindRelationsNotFoundError } from "../error/FindRelationsNotFoundError";
import { DriverUtils } from "../driver/DriverUtils";
/**
 * Utilities to work with FindOptions.
 */
export var FindOptionsUtils = /*#__PURE__*/function () {
  function FindOptionsUtils() {
    _classCallCheck(this, FindOptionsUtils);
  }
  _createClass(FindOptionsUtils, null, [{
    key: "isFindOneOptions",
    value:
    // -------------------------------------------------------------------------
    // Public Static Methods
    // -------------------------------------------------------------------------
    /**
     * Checks if given object is really instance of FindOneOptions interface.
     */
    function isFindOneOptions(obj) {
      var possibleOptions = obj;
      return possibleOptions && (Array.isArray(possibleOptions.select) || Array.isArray(possibleOptions.relations) || typeof possibleOptions.select === "object" || typeof possibleOptions.relations === "object" || typeof possibleOptions.where === "object" ||
      // typeof possibleOptions.where === "string" ||
      typeof possibleOptions.join === "object" || typeof possibleOptions.order === "object" || typeof possibleOptions.cache === "object" || typeof possibleOptions.cache === "boolean" || typeof possibleOptions.cache === "number" || typeof possibleOptions.comment === "string" || typeof possibleOptions.lock === "object" || typeof possibleOptions.loadRelationIds === "object" || typeof possibleOptions.loadRelationIds === "boolean" || typeof possibleOptions.loadEagerRelations === "boolean" || typeof possibleOptions.withDeleted === "boolean" || typeof possibleOptions.relationLoadStrategy === "string" || typeof possibleOptions.transaction === "boolean");
    }
    /**
     * Checks if given object is really instance of FindManyOptions interface.
     */
  }, {
    key: "isFindManyOptions",
    value: function isFindManyOptions(obj) {
      var possibleOptions = obj;
      return possibleOptions && (this.isFindOneOptions(possibleOptions) || typeof possibleOptions.skip === "number" || typeof possibleOptions.take === "number" || typeof possibleOptions.skip === "string" || typeof possibleOptions.take === "string");
    }
    /**
     * Checks if given object is really instance of FindOptions interface.
     */
  }, {
    key: "extractFindManyOptionsAlias",
    value: function extractFindManyOptionsAlias(object) {
      if (this.isFindManyOptions(object) && object.join) return object.join.alias;
      return undefined;
    }
    /**
     * Applies give find many options to the given query builder.
     static applyFindManyOptionsOrConditionsToQueryBuilder<T>(qb: SelectQueryBuilder<T>, options: FindManyOptions<T>|Partial<T>|undefined): SelectQueryBuilder<T> {
        if (this.isFindManyOptions(options))
            return this.applyOptionsToQueryBuilder(qb, options);
         if (options)
            return qb.where(options);
         return qb;
    }*/
    /**
     * Applies give find options to the given query builder.
     static applyOptionsToQueryBuilder<T>(qb: SelectQueryBuilder<T>, options: FindOneOptions<T>|FindManyOptions<T>|undefined): SelectQueryBuilder<T> {
         // if options are not set then simply return query builder. This is made for simplicity of usage.
        if (!options || (!this.isFindOneOptions(options) && !this.isFindManyOptions(options)))
            return qb;
         if (options.transaction === true) {
            qb.expressionMap.useTransaction = true;
        }
         if (!qb.expressionMap.mainAlias || !qb.expressionMap.mainAlias.hasMetadata)
            return qb;
         const metadata = qb.expressionMap.mainAlias!.metadata;
         // apply all options from FindOptions
        if (options.comment) {
            qb.comment(options.comment);
        }
         if (options.withDeleted) {
            qb.withDeleted();
        }
         if (options.select) {
            qb.select([]);
            options.select.forEach(select => {
                if (!metadata.hasColumnWithPropertyPath(`${select}`))
                    throw new TypeORMError(`${select} column was not found in the ${metadata.name} entity.`);
                 const columns = metadata.findColumnsWithPropertyPath(`${select}`);
                 for (const column of columns) {
                    qb.addSelect(qb.alias + "." + column.propertyPath);
                }
            });
        }
         if (options.relations) {
            // Copy because `applyRelationsRecursively` modifies it
            const allRelations = [...options.relations];
            this.applyRelationsRecursively(qb, allRelations, qb.expressionMap.mainAlias!.name, qb.expressionMap.mainAlias!.metadata, "");
            // recursive removes found relations from allRelations array
            // if there are relations left in this array it means those relations were not found in the entity structure
            // so, we give an exception about not found relations
            if (allRelations.length > 0)
                throw new FindRelationsNotFoundError(allRelations);
        }
         if (options.join) {
            if (options.join.leftJoin)
                Object.keys(options.join.leftJoin).forEach(key => {
                    qb.leftJoin(options.join!.leftJoin![key], key);
                });
             if (options.join.innerJoin)
                Object.keys(options.join.innerJoin).forEach(key => {
                    qb.innerJoin(options.join!.innerJoin![key], key);
                });
             if (options.join.leftJoinAndSelect)
                Object.keys(options.join.leftJoinAndSelect).forEach(key => {
                    qb.leftJoinAndSelect(options.join!.leftJoinAndSelect![key], key);
                });
             if (options.join.innerJoinAndSelect)
                Object.keys(options.join.innerJoinAndSelect).forEach(key => {
                    qb.innerJoinAndSelect(options.join!.innerJoinAndSelect![key], key);
                });
        }
         if (options.cache) {
            if (options.cache instanceof Object) {
                const cache = options.cache as { id: any, milliseconds: number };
                qb.cache(cache.id, cache.milliseconds);
            } else {
                qb.cache(options.cache);
            }
        }
         if (options.lock) {
            if (options.lock.mode === "optimistic") {
                qb.setLock(options.lock.mode, options.lock.version);
            } else if (
                options.lock.mode === "pessimistic_read" ||
                options.lock.mode === "pessimistic_write" ||
                options.lock.mode === "dirty_read" ||
                options.lock.mode === "pessimistic_partial_write" ||
                options.lock.mode === "pessimistic_write_or_fail" ||
                options.lock.mode === "for_no_key_update" ||
                options.lock.mode === "for_key_share"
            ) {
                const tableNames = options.lock.tables ? options.lock.tables.map((table) => {
                    const tableAlias = qb.expressionMap.aliases.find((alias) => {
                        return alias.metadata.tableNameWithoutPrefix === table;
                    });
                    if (!tableAlias) {
                        throw new TypeORMError(`"${table}" is not part of this query`);
                    }
                    return qb.escape(tableAlias.name);
                }) : undefined;
                qb.setLock(options.lock.mode, undefined, tableNames);
            }
        }
         if (options.loadRelationIds === true) {
            qb.loadAllRelationIds();
         } else if (options.loadRelationIds instanceof Object) {
            qb.loadAllRelationIds(options.loadRelationIds as any);
        }
         if (options.where)
            qb.where(options.where);
         if ((options as FindManyOptions<T>).skip)
            qb.skip((options as FindManyOptions<T>).skip!);
         if ((options as FindManyOptions<T>).take)
            qb.take((options as FindManyOptions<T>).take!);
         if (options.order)
            Object.keys(options.order).forEach(key => {
                const order = ((options as FindOneOptions<T>).order as any)[key as any];
                 if (!metadata.findColumnWithPropertyPath(key))
                    throw new Error(`${key} column was not found in the ${metadata.name} entity.`);
                 switch (order) {
                    case 1:
                        qb.addOrderBy(qb.alias + "." + key, "ASC");
                        break;
                    case -1:
                        qb.addOrderBy(qb.alias + "." + key, "DESC");
                        break;
                    case "ASC":
                        qb.addOrderBy(qb.alias + "." + key, "ASC");
                        break;
                    case "DESC":
                        qb.addOrderBy(qb.alias + "." + key, "DESC");
                        break;
                }
            });
         return qb;
    }*/
  }, {
    key: "applyOptionsToTreeQueryBuilder",
    value: function applyOptionsToTreeQueryBuilder(qb, options) {
      if (options === null || options === void 0 ? void 0 : options.relations) {
        // Copy because `applyRelationsRecursively` modifies it
        var allRelations = _toConsumableArray(options.relations);
        FindOptionsUtils.applyRelationsRecursively(qb, allRelations, qb.expressionMap.mainAlias.name, qb.expressionMap.mainAlias.metadata, "");
        // recursive removes found relations from allRelations array
        // if there are relations left in this array it means those relations were not found in the entity structure
        // so, we give an exception about not found relations
        if (allRelations.length > 0) throw new FindRelationsNotFoundError(allRelations);
      }
      return qb;
    }
    // -------------------------------------------------------------------------
    // Protected Static Methods
    // -------------------------------------------------------------------------
    /**
     * Adds joins for all relations and sub-relations of the given relations provided in the find options.
     */
  }, {
    key: "applyRelationsRecursively",
    value: function applyRelationsRecursively(qb, allRelations, alias, metadata, prefix) {
      var _this = this;
      // find all relations that match given prefix
      var matchedBaseRelations = [];
      if (prefix) {
        var regexp = new RegExp("^" + prefix.replace(".", "\\.") + "\\.");
        matchedBaseRelations = allRelations.filter(function (relation) {
          return relation.match(regexp);
        }).map(function (relation) {
          return relation.replace(regexp, "");
        }).filter(function (relation) {
          return metadata.findRelationWithPropertyPath(relation);
        });
      } else {
        matchedBaseRelations = allRelations.filter(function (relation) {
          return metadata.findRelationWithPropertyPath(relation);
        });
      }
      // go through all matched relations and add join for them
      matchedBaseRelations.forEach(function (relation) {
        // generate a relation alias
        var relationAlias = DriverUtils.buildAlias(qb.connection.driver, {
          joiner: "__"
        }, alias, relation);
        // add a join for the found relation
        var selection = alias + "." + relation;
        qb.leftJoinAndSelect(selection, relationAlias);
        // remove added relations from the allRelations array, this is needed to find all not found relations at the end
        allRelations.splice(allRelations.indexOf(prefix ? prefix + "." + relation : relation), 1);
        // try to find sub-relations
        var join = qb.expressionMap.joinAttributes.find(function (join) {
          return join.entityOrProperty === selection;
        });
        _this.applyRelationsRecursively(qb, allRelations, join.alias.name, join.metadata, prefix ? prefix + "." + relation : relation);
        // join the eager relations of the found relation
        var relMetadata = metadata.relations.find(function (metadata) {
          return metadata.propertyName === relation;
        });
        if (relMetadata) {
          _this.joinEagerRelations(qb, relationAlias, relMetadata.inverseEntityMetadata);
        }
      });
    }
  }, {
    key: "joinEagerRelations",
    value: function joinEagerRelations(qb, alias, metadata) {
      var _this2 = this;
      metadata.eagerRelations.forEach(function (relation) {
        // generate a relation alias
        var relationAlias = DriverUtils.buildAlias(qb.connection.driver, qb.connection.namingStrategy.eagerJoinRelationAlias(alias, relation.propertyPath));
        // add a join for the relation
        // Checking whether the relation wasn't joined yet.
        var addJoin = true;
        var _iterator = _createForOfIteratorHelper(qb.expressionMap.joinAttributes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var join = _step.value;
            if (join.condition !== undefined || join.mapToProperty !== undefined || join.isMappingMany !== undefined || join.direction !== "LEFT" || join.entityOrProperty !== "".concat(alias, ".").concat(relation.propertyPath)) {
              continue;
            }
            addJoin = false;
            relationAlias = join.alias.name;
            break;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (addJoin) {
          qb.leftJoin(alias + "." + relation.propertyPath, relationAlias);
        }
        // Checking whether the relation wasn't selected yet.
        // This check shall be after the join check to detect relationAlias.
        var addSelect = true;
        var _iterator2 = _createForOfIteratorHelper(qb.expressionMap.selects),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var select = _step2.value;
            if (select.aliasName !== undefined || select.virtual !== undefined || select.selection !== relationAlias) {
              continue;
            }
            addSelect = false;
            break;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (addSelect) {
          qb.addSelect(relationAlias);
        }
        // (recursive) join the eager relations
        _this2.joinEagerRelations(qb, relationAlias, relation.inverseEntityMetadata);
      });
    }
  }]);
  return FindOptionsUtils;
}();